// extracted by mini-css-extract-plugin
export default {"imageContainer":"GetEmployee_imageContainer__CxLJ7","seller":"GetEmployee_seller__xzhsF","sellerName":"GetEmployee_sellerName__l80Ma","sellerId":"GetEmployee_sellerId__7TGSJ"};